import { handleResponse, makeGet } from './helpers';

type GetBidderRefundsAdminParams = {
    authToken: string;
    deployment: string;
    from: string;
    keyword: string;
    page: number;
    pageSize: number | 'all';
    to: string;
};

export const getBidderRefundsAdmin = ({
    authToken,
    deployment,
    from,
    keyword,
    page,
    pageSize,
    to,
}: GetBidderRefundsAdminParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ apiPath: 'admin/refunds', authToken, deployment, path: '<PAYMENT-API>' });
        request.query({
            from,
            keyword,
            page,
            pageSize,
            to,
        });
        request.end((err, response) => handleResponse({ err, reject, resolve, response }));
    });
